/**
 * D2-F1 / G2 — derive the private-chat counterparty for «Написати партнеру».
 * Server-authoritative Deal fields only; fail closed.
 * Company is never a chat user target.
 */

import { DEAL_SIDE_KIND } from "./dealSidePresentation";

const isValidUserId = (id) => {
  if (id == null || id === "") return false;
  const parsed = Number(id);
  return Number.isFinite(parsed) && Number.isInteger(parsed) && parsed > 0;
};

function counterpartySide(viewerRole) {
  if (viewerRole === "seller") return "buyer";
  if (viewerRole === "buyer") return "seller";
  return null;
}

function sideKind(deal, side) {
  const raw = deal && deal[`${side}_side_kind`];
  if (raw === DEAL_SIDE_KIND.COMPANY) return DEAL_SIDE_KIND.COMPANY;
  return DEAL_SIDE_KIND.PERSONAL;
}

/**
 * @param {object|null|undefined} deal
 * @returns {{ id: number|string }|null} counterparty user with valid id, or null
 */
export function getDealPartnerChatTarget(deal) {
  if (!deal || deal.is_internal === true) return null;

  const status = deal.status;
  if (status !== "pending" && status !== "in_progress") return null;

  const side = counterpartySide(deal.viewer_role);
  if (!side) return null;

  const kind = sideKind(deal, side);
  let target = null;
  if (kind === DEAL_SIDE_KIND.COMPANY) {
    // Only the safe projected representative — never historical realtor.
    target = deal[`${side}_representative`] || null;
  } else {
    target = deal[`${side}_realtor`] || null;
  }

  if (!target || !isValidUserId(target.id)) return null;
  return target;
}

export default getDealPartnerChatTarget;
